import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Check } from '@styled-icons/material/Check';
import { TextVariant } from '@naf/text';
import { ProductID } from '@lib/ProductID';
import useSelector from '@redux/typedHooks';
import { actions } from '@redux/modules/myMembership';
import { useAuth0Token } from '@hooks/useAuth0Token';
import * as S from './ActiveChargingTags.styles';

export const ActiveChargingTagsBlock = () => {
  const dispatch = useDispatch();
  const [didFetch, setDidFetfch] = useState(false);
  const { simpleToken } = useAuth0Token();

  const chargingTagData = useSelector((state) => state.myMembership.customerInformation.data.services)?.filter(
    (e) => e.product.id === ProductID.ChargingTag,
  );

  useEffect(() => {
    if (!chargingTagData && simpleToken && !didFetch) {
      setDidFetfch(true);
      dispatch(actions.getMyMembership.request(simpleToken, {}));
    }
  }, [simpleToken, dispatch, chargingTagData, didFetch]);

  // TODO: Update component when API/CRM handles charging tags as it is supposed to.

  const [chargingTagService] = chargingTagData;

  // TODO: Fix this when charging tag data is rewritten
  const chargingTags = chargingTagService?.data?.split(',') || [];

  return chargingTags && chargingTags.length > 0 ? (
    <>
      <S.Header variant={TextVariant.ArticleTextHeader}>
        {chargingTagData.length > 1
          ? `Du har ${chargingTags.length} aktive ladebrikker.`
          : `Du har ${chargingTags.length} aktiv ladebrikke.`}
      </S.Header>
      <S.ChargingTagList>
        {chargingTags &&
          chargingTags.map((tagName) => (
            <S.ChargingTagItem key={tagName}>
              <S.StyledCheck>
                <Check size={16} />
              </S.StyledCheck>
              <S.TextWrapper>{tagName} - aktiv</S.TextWrapper>
            </S.ChargingTagItem>
          ))}
      </S.ChargingTagList>
    </>
  ) : (
    <S.Header>Du har ingen aktiverte ladebrikker.</S.Header>
  );
};
